import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
import { CartTriggerFragment } from '@magento/peregrine/lib/talons/Header/cartTriggerFragments.gql';
export var GET_ITEM_COUNT_QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getItemCount($cartId: String!) {\n    cart(cart_id: $cartId) {\n      id\n      ...CartTriggerFragment\n    }\n  }\n  ", "\n"])), CartTriggerFragment);